<template>
  <div class="fenxiao-withdraw-apply">
    <!-- 页面标题 -->
    <div class="page-header">
      <h2>提现申请</h2>
    </div>

    <!-- 提现表单 -->
    <div class="withdraw-form">
      <div class="form-card">
        <div class="withdraw-info">
          <div class="title">佣金将提现到余额</div>
          <div class="money-input">
            <span class="currency">¥</span>
            <el-input
              v-model="withdrawMoney"
              type="number"
              placeholder="请输入提现金额"
              class="money-field"
              :min="0"
              :max="fenxiaoInfo.account"
            />
          </div>
          <div class="available-amount">
            可提现佣金：¥{{ fenxiaoInfo.account | moneyFormat }}
          </div>
        </div>
        
        <div class="withdraw-desc">
          最小提现金额为¥{{ withdrawConfig.withdraw | moneyFormat }}
        </div>
        
        <div class="form-actions">
          <el-button 
            type="primary" 
            size="large"
            :disabled="!canWithdraw"
            :loading="isSubmitting"
            @click="handleWithdraw"
            class="withdraw-btn"
          >
            提现到余额
          </el-button>
          
          <el-button 
            type="default" 
            size="large"
            @click="goToWithdrawList"
            class="list-btn"
          >
            提现明细
          </el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fenxiaoDetail, withdrawApply, withdrawConfig } from '@/api/fenxiao/fenxiao'

export default {
  name: 'FenxiaoWithdrawApply',
  data() {
    return {
      fenxiaoInfo: {
        account: 0
      },
      withdrawConfig: {
        withdraw: 0
      },
      withdrawMoney: '',
      isSubmitting: false
    }
  },
  computed: {
    canWithdraw() {
      const money = parseFloat(this.withdrawMoney)
      return (
        this.withdrawMoney !== '' &&
        !isNaN(money) &&
        money > 0 &&
        money >= parseFloat(this.withdrawConfig.withdraw) &&
        money <= parseFloat(this.fenxiaoInfo.account)
      )
    }
  },
  mounted() {
    this.getFenxiaoInfo()
    this.getWithdrawConfig()
  },
  methods: {
    // 获取分销商信息
    async getFenxiaoInfo() {
      try {
        const response = await fenxiaoDetail()
        if (response.code === 0 && response.data) {
          this.fenxiaoInfo = response.data
        } else {
          this.$message.error(response.message || '获取分销信息失败')
          // 如果不是分销商，跳转到申请页面
          this.$router.push('/member/fenxiao_apply')
        }
      } catch (error) {
        console.error('获取分销信息失败:', error)
        this.$message.error('获取分销信息失败')
      }
    },

    // 获取提现配置
    async getWithdrawConfig() {
      try {
        const response = await withdrawConfig()
        if (response.code === 0 && response.data) {
          this.withdrawConfig = response.data
        }
      } catch (error) {
        console.error('获取提现配置失败:', error)
      }
    },

    // 验证提现金额
    validateWithdraw() {
      const money = parseFloat(this.withdrawMoney)
      
      if (this.withdrawMoney === '' || isNaN(money) || money <= 0) {
        this.$message.error('请输入有效的提现金额')
        return false
      }
      
      if (money > parseFloat(this.fenxiaoInfo.account)) {
        this.$message.error('提现金额超出可提现金额')
        return false
      }
      
      if (money < parseFloat(this.withdrawConfig.withdraw)) {
        this.$message.error('提现金额小于最低提现金额')
        return false
      }
      
      return true
    },

    // 提交提现申请
    async handleWithdraw() {
      if (!this.validateWithdraw()) {
        return
      }

      this.isSubmitting = true
      
      try {
        const response = await withdrawApply({
          money: this.withdrawMoney
        })
        
        if (response.code === 0) {
          this.$message.success('提现申请成功')
          setTimeout(() => {
            this.$router.push('/member/fenxiao_withdraw_list')
          }, 1500)
        } else {
          this.$message.error(response.message || '提现申请失败')
        }
      } catch (error) {
        console.error('提现申请失败:', error)
        this.$message.error('提现申请失败')
      } finally {
        this.isSubmitting = false
      }
    },

    // 跳转到提现明细
    goToWithdrawList() {
      this.$router.push('/member/fenxiao_withdraw_list')
    }
  },
  filters: {
    // 金额格式化
    moneyFormat(money) {
      return parseFloat(money || 0).toFixed(2)
    }
  }
}
</script>

<style lang="scss" scoped>
.fenxiao-withdraw-apply {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: calc(100vh - 60px);

  .page-header {
    margin-bottom: 20px;
    
    h2 {
      color: #333;
      font-size: 24px;
      font-weight: 500;
      margin: 0;
    }
  }

  .withdraw-form {
    max-width: 600px;
    margin: 0 auto;

    .form-card {
      background: #fff;
      border-radius: 8px;
      padding: 30px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

      .withdraw-info {
        margin-bottom: 30px;

        .title {
          font-size: 16px;
          color: #666;
          margin-bottom: 20px;
        }

        .money-input {
          display: flex;
          align-items: center;
          margin-bottom: 15px;
          padding-bottom: 15px;
          border-bottom: 1px solid #e8e8e8;

          .currency {
            font-size: 36px;
            font-weight: 500;
            color: #333;
            margin-right: 10px;
          }

          .money-field {
            flex: 1;
            
            ::v-deep .el-input__inner {
              border: none;
              padding: 0;
              font-size: 36px;
              font-weight: 500;
              height: 50px;
              line-height: 50px;
              
              &:focus {
                border: none;
                box-shadow: none;
              }
            }
          }
        }

        .available-amount {
          font-size: 14px;
          color: #999;
        }
      }

      .withdraw-desc {
        font-size: 14px;
        color: #999;
        margin-bottom: 30px;
        padding: 15px;
        background-color: #f8f9fa;
        border-radius: 4px;
      }

      .form-actions {
        display: flex;
        flex-direction: column;
        gap: 15px;

        .withdraw-btn {
          width: 100%;
          height: 50px;
          font-size: 16px;
          border-radius: 25px;
          
          &:disabled {
            background-color: #ccc;
            border-color: #ccc;
          }
        }

        .list-btn {
          width: 100%;
          height: 50px;
          font-size: 16px;
          border-radius: 25px;
          border: 2px solid #ddd;
          color: #666;
          
          &:hover {
            border-color: #409eff;
            color: #409eff;
          }
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .fenxiao-withdraw-apply {
    padding: 15px;

    .withdraw-form {
      .form-card {
        padding: 20px;
        
        .withdraw-info {
          .money-input {
            .currency {
              font-size: 28px;
            }
            
            .money-field {
              ::v-deep .el-input__inner {
                font-size: 28px;
                height: 40px;
                line-height: 40px;
              }
            }
          }
        }
      }
    }
  }
}
</style>